import { LanguageEnum } from '../../utils';

export const copyWritings = {
  more: {
    [LanguageEnum.chinese]: '点击展开全部内容',
    [LanguageEnum.english]: 'Click to expand',
  },
};
